/* eslint-disable no-unused-vars */

/* eslint-disable no-param-reassign */
import produce from "immer";

import {
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  SILENT_LOGIN,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS
} from "src/actions/accountActions";

const initialState = {
  user: null
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST: {
      return produce(state, (draft) => {
        // Ensure we clear current session
        draft.user = null;
      });
    }

    case LOGIN_SUCCESS: {
      const {user} = action.payload;

      return produce(state, (draft) => {
        draft.user = user;
      });
    }

    case LOGIN_FAILURE: {
      return produce(state, () => {
        // Maybe store error
      });
    }

    case FORGOT_PASSWORD_REQUEST: {
      return produce(state, (draft) => {});
    }

    case FORGOT_PASSWORD_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {});
    }

    case FORGOT_PASSWORD_FAILURE: {
      return produce(state, () => {});
    }

    case RESET_PASSWORD_REQUEST: {
      return produce(state, (draft) => {});
    }

    case RESET_PASSWORD_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {});
    }

    case RESET_PASSWORD_FAILURE: {
      return produce(state, () => {});
    }

    case LOGOUT: {
      return produce(state, (draft) => {
        draft.user = null;
      });
    }

    case SILENT_LOGIN: {
      const {user} = action.payload;

      return produce(state, (draft) => {
        draft.user = user;
      });
    }

    case UPDATE_PROFILE_REQUEST: {
      return produce(state, (draft) => {});
    }

    case UPDATE_PROFILE_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.user = response;
      });
    }

    case UPDATE_PROFILE_FAILURE: {
      return produce(state, (draft) => {});
    }

    default: {
      return state;
    }
  }
};

export default accountReducer;
